import axios from 'axios';
import qs from 'qs';
import { PRODUCT_API_BASE, CONTENT_API_BASE, IDENTITY_SERVER_BASE, API_CLIENT_ID, API_CLIENT_SECRET, API_SCOPE } from '../config';

import {
  PRODUCT_BY_ID,
  PRODUCT_BY_ID_SUCCESS,
  PRODUCT_BY_ID_FAILURE,
  ALL_PRODUCTS,
  ALL_PRODUCTS_SUCCESS,
  ALL_PRODUCTS_FAILURE,
  HOMEPAGE_CONTENT,
  HOMEPAGE_CONTENT_SUCCESS,
  HOMEPAGE_CONTENT_FAILURE,
  AUTH_SUCCESS,
  AUTH_FAILURE,
  ALL_NAVIGATION,
  ALL_NAVIGATION_SUCCESS,
  ALL_NAVIGATION_FAILURE,
  CONTENT_PAGE,
  CONTENT_PAGE_SUCCESS,
  CONTENT_PAGE_FAILURE,
} from './mutation-types';

export const authorisationActions = {
  getToken({ commit }) {
    const axiosConfig = {
      baseURL: { IDENTITY_SERVER_BASE },
      timeout: 30000,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };

    const requestData = {
      client_id: `${API_CLIENT_ID}`,
      client_secret: `${API_CLIENT_SECRET}`,
      grant_type: 'client_credentials',
      scope: `${API_SCOPE}`,
    };

    try {
      axios.post(`${IDENTITY_SERVER_BASE}/connect/token`, qs.stringify(requestData), axiosConfig).then((response) => {
        const token = response.data.access_token;
        commit(AUTH_SUCCESS, token);
      }).catch((error) => {
        if (error) {
          commit(AUTH_FAILURE);
        }
      });
    } catch (err) {
      commit(AUTH_FAILURE);
    }
  },
};

export const productActions = {
  allProducts({ commit, state }) {
    try {
      commit(ALL_PRODUCTS);
      const config = {
        headers: {
          Authorization: `bearer ${state.token}`,
        },
      };
      axios.get(`${PRODUCT_API_BASE}/Product`, config).then((response) => {
        commit(ALL_PRODUCTS_SUCCESS, response.data);
      }).catch((error) => {
        if (error) {
          commit(ALL_PRODUCTS_FAILURE);
        }
      });
    } catch (error) {
      commit(ALL_PRODUCTS_FAILURE);
    }
  },
  productById({ commit, state }, payload) {
    try {
      commit(PRODUCT_BY_ID);
      const config = {
        headers: {
          Authorization: `bearer ${state.token}`,
        },
      };
      axios.get(`${PRODUCT_API_BASE}/Product/${payload}`, config).then((response) => {
        commit(PRODUCT_BY_ID_SUCCESS, response.data);
      }).catch((error) => {
        if (error) {
          commit(PRODUCT_BY_ID_FAILURE);
        }
      });
    } catch (error) {
      commit(PRODUCT_BY_ID_FAILURE);
    }
  },
};

export const contentActions = {
  getHomepageContent({ commit, state }) {
    try {
      commit(HOMEPAGE_CONTENT);
      const config = {
        headers: {
          Authorization: `bearer ${state.token}`,
        },
      };
      axios.get(`${CONTENT_API_BASE}/homepage`, config).then((response) => {
        commit(HOMEPAGE_CONTENT_SUCCESS, response.data);
      }).catch((error) => {
        if (error) {
          commit(HOMEPAGE_CONTENT_FAILURE);
        }
      });
    } catch (error) {
      commit(HOMEPAGE_CONTENT_FAILURE);
    }
  },
  getNavigation({ commit, state }) {
    try {
      commit(ALL_NAVIGATION);
      const config = {
        headers: {
          Authorization: `bearer ${state.token}`,
        },
      };
      axios.get(`${CONTENT_API_BASE}/content`, config).then((response) => {
        commit(ALL_NAVIGATION_SUCCESS, response.data);
      }).catch((error) => {
        if (error) {
          commit(ALL_NAVIGATION_FAILURE);
        }
      });
    } catch (error) {
      commit(ALL_NAVIGATION_FAILURE);
    }
  },
  getContent({ commit, state }, payload) {
    try {
      commit(CONTENT_PAGE);
      const config = {
        headers: {
          Authorization: `bearer ${state.token}`,
        },
      };
      axios.get(`${CONTENT_API_BASE}/content/${payload}`, config).then((response) => {
        commit(CONTENT_PAGE_SUCCESS, response.data);
      }).catch((error) => {
        if (error) {
          commit(CONTENT_PAGE_FAILURE);
        }
      });
    } catch (error) {
      commit(CONTENT_PAGE_FAILURE);
    }
  },
  async sendMessage({ state }, payload) {
    try {
      const config = {
        headers: {
          Authorization: `bearer ${state.token}`,
        },
      };
      const message = {
        ...payload,
        method: 'DEFAULT',
      };
      axios.post(`${CONTENT_API_BASE}/interact`, message, config);
    } catch (error) {
      console.log('Error sending message');
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js